export default "__VITE_ASSET__GBvzaEMT__"